import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxIconModule } from '../icon/icon.module';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';
import { PhxButtonUpsellComponent } from './phx-button-upsell.component';

@NgModule({
  declarations: [PhxButtonUpsellComponent],
  imports: [CommonModule, PhxIconModule, PhxSpinnerModule],
  exports: [PhxButtonUpsellComponent],
})
export class PhxButtonUpsellModule {}
